
export default {
  data() {
    return {
      gap: null,
      widthWrapperWthGap: null,
      heighthWrapperWthGap: null,
      widthItem: null,
      heightItem: null,
      leftMove: null,
      highlight: null,
      isDesktop: null,
    };
  },

  head() {
    return {
      title: "ALEO - L'Agence de Communication des Pros",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "L'Agence de Communication des Pros. Indépendants, petites et moyennes entreprises, découvrez ALEO, l'offre qui booste votre activité.",
        },
      ],
    };
  },
  mounted() {
    const wrapper = document.querySelector(".section-steps__steps-wrapper");
    const progress = document.querySelector(".progress");
    this.highlight = document.querySelector(".section-steps__highlight");

    this.leftMove = 0;
    this.isDesktopMatches();

    this.$nextTick(() => {
      if (this.isDesktop) {
        this.gap = 56;
        this.widthWrapperWthGap = wrapper.offsetWidth - this.gap * 3;
        this.widthItem = this.widthWrapperWthGap / 4;
        this.highlight.style.width = this.widthItem + "px";
        progress.style.width = (wrapper.offsetWidth * 97) / 100 + "px";
        progress.style.height = "2px";
      } else {
        this.gap = 0;
        this.heighthWrapperWthGap = wrapper.offsetHeight - this.gap * 3;
        this.heightItem = this.heighthWrapperWthGap / 4;
        this.highlight.style.width = "100%";
        this.highlight.style.height = this.heightItem + "px";
        this.highlight.style.top = 0;
        progress.style.width = "2px";
        progress.style.height = (wrapper.offsetHeight * 87) / 100 + "px";
      }
      setTimeout(() => {
        this.progressEffect();
      }, 1000);

      window.addEventListener("resize", () => {
        this.isDesktopMatches();
        if (this.isDesktop) {
          this.gap = 56;
          this.widthWrapperWthGap = wrapper.offsetWidth - this.gap * 3;
          this.widthItem = this.widthWrapperWthGap / 4;
          this.highlight.style.width = this.widthItem + "px";
          this.highlight.style.height = "100%";
          this.highlight.style.left = this.widthItem + this.gap + "px";
          progress.style.width = (wrapper.offsetWidth * 97) / 100 + "px";
          progress.style.height = "2px";
        } else {
          this.gap = 0;
          this.heighthWrapperWthGap = wrapper.offsetHeight - this.gap * 3;
          this.heightItem = this.heighthWrapperWthGap / 4;
          this.highlight.style.width = "100%";
          this.highlight.style.height = this.heightItem + "px";
          //  this.highlight.style.top = this.heightItem + this.gap + "px";
          progress.style.width = "2px";
          progress.style.height = (wrapper.offsetHeight * 87) / 100 + "px";
        }
      });
    });
  },

  methods: {
    progressEffect() {
      const mm = this.$gsap.matchMedia();
      mm.add(
        {
          isDesktop: "(min-width: 1024px)",
          isMobileTablet: "(max-width: 1023px)",
        },
        (context) => {
          const { isDesktop } = context.conditions;
          this.$gsap
            .timeline({
              scrollTrigger: {
                trigger: ".section-steps__steps-wrapper",
                start: "top 70%",
              },
            })
            .to(".progress-red", {
              width: isDesktop ? "37%" : "2px",
              height: isDesktop ? "2px" : "230px",
              duration: 1,
              ease: "none",
            })
            .to(
              isDesktop ? ".step-2" : ".step-2 > img",
              {
                scale: 1.4,
              },
              ">"
            )
            .to(
              ".section-steps__highlight",
              {
                left: isDesktop ? this.widthItem + this.gap : 0,
                top: isDesktop ? 0 : this.heightItem + this.gap,
                ease: "none",
              },
              "<-0.1"
            )
            .to(
              isDesktop ? ".step-2" : ".step-2 > img",
              {
                scale: 1,
              },
              ">"
            )
            .to(
              ".step-2-image",
              {
                opacity: 1,
              },
              "<"
            )
            .to(
              ".section-steps__step-2 p",
              {
                opacity: 1,
              },
              "<"
            );
        }
      );
    },

    isDesktopMatches() {
      this.isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    },
  },
};
